export const USER_INVITATION_POPUP_LABELS = {
	copyButton: 'Copy',
	copyTarget: 'Link',
	invitationInstructions:
		'They can also use this invitation link below - feel free to copy and send it to them.',
	sentEmailPrefix: 'We sent an email to',
	sentEmailSuffix: 'and invited them to join your account at Evinced.',
	title: 'Email invitation sent'
};
